// @ts-check
import { View } from '@react-pdf/renderer';
import React from 'react';
import { Text, Title, useTheme } from '../../../pdf-design-system';
import { floors } from '../helpers/rooms';
import { RoomProvider } from '../useRoom';
import VieVinumLogo from '../VieVinumLogo';
import StaticCatalogPageContent from './StaticCatalogPageContent';
import VieVinumPageFrame from './VieVinumPageFrame';

/**
 *
 * @param {{
 * bleed: number;
 * [x: string]: any;
 * }} props
 * @returns
 */
export default function VieVinumIntro({ bleed, ...rest }) {
  const introRoom = {
    floor: { name: 'none', slug: 'none' },
    colors: { primary: 'rgb(84, 86, 86)' },
  };
  return (
    <RoomProvider value={{ ...introRoom, name: 'Vorwort' }}>
      <VieVinumPageFrame bleed={bleed}>
        <StaticCatalogPageContent />
      </VieVinumPageFrame>
      <VieVinumPageFrame bleed={bleed}>
        <StaticCatalogPageContent />
      </VieVinumPageFrame>
      <RoomProvider value={{ ...introRoom, name: 'Inhalt' }}>
        <VieVinumPageFrame bleed={bleed}>
          <StaticCatalogPageContent />
          {/* <Stencil /> */}
          <TableOfContents />
        </VieVinumPageFrame>
      </RoomProvider>
      <RoomProvider value={{ ...introRoom, name: 'Impressum' }}>
        <VieVinumPageFrame bleed={bleed}>
          <StaticCatalogPageContent />
        </VieVinumPageFrame>
      </RoomProvider>
    </RoomProvider>
  );
}

function TableOfContents() {
  const { theme } = useTheme();
  return (
    <View style={{ height: '100%', marginLeft: '6mm' }}>
      <VieVinumLogo
        color={theme.colors.primary}
        style={{
          width: '34.5mm',
          height: '23mm',
          position: 'absolute',
          right: 0,
        }}
      />
      <View style={{ marginTop: '35mm' }}>
        <Floor floor={floors.parterre} />
        <Floor floor={floors.mezzanin} />
      </View>
    </View>
  );
}

function Floor({ floor, ...rest }) {
  return (
    <View style={{ flexDirection: 'column', paddingBottom: '5mm' }} {...rest}>
      <Title
        style={{
          borderBottom: '1pt solid #000',
          marginBottom: '3mm',
          paddingBottom: 1,
        }}
      >
        {floor.name}
      </Title>
      {floor.rooms.map((room) => (
        <Room key={room.slug} room={room} />
      ))}
    </View>
  );
}

/** @param {{room: import('../helpers/rooms').Room}} props */
function Room({ room, ...rest }) {
  return (
    <View style={{ flexDirection: 'row', marginBottom: '1.8mm' }}>
      <Text
        variant="largeMedium"
        style={{
          width: '35mm',
          marginRight: '1mm',
          color: room.colors?.primary,
          textTransform: 'uppercase',
          paddingTop: 1,
        }}
      >
        {room.name}
      </Text>
      <Text
        variant="largeMedium"
        style={{
          width: '16mm',
          paddingHorizontal: '2mm',
          paddingTop: 1,
          backgroundColor: room.colors?.primary,
          color: room.colors?.onPrimary || '#fff',
          marginRight: '5mm',
          alignSelf: 'flex-start',
        }}
      >
        {room.tableNumbers || ' '}
      </Text>
      <Text variant="large" style={{ width: '80mm', paddingTop: 1 }}>
        {room.subtitle}
      </Text>
    </View>
  );
}

// function Stencil() {
//   return (
//     <Image
//       src={tocStencil}
//       fixed
//       style={{
//         position: 'absolute',
//         top: '-8mm',
//         left: '-8mm',
//         bottom: '-8mm',
//         right: '-8mm',
//         opacity: 0.3,
//       }}
//     />
//   );
// }
